import { ACTIONS } from './actions'
import { CONTROLLERS } from './controller'

export const apiPaths = {
  login: CONTROLLERS.Account + ACTIONS.LOGIN,
  GET_DOCTOR: CONTROLLERS.OnlineReserveTime + ACTIONS.GET_DOCTORS,
  GET_DOCTOR_CENTER: CONTROLLERS.OnlineReserveTime + ACTIONS.GET_DOCTOR_CENTER,
  GET_DOCTOR_TIMES: CONTROLLERS.OnlineReserveTime + ACTIONS.GET_DOCTOR_TIMES,
  SendConfirmationCode: CONTROLLERS.OnlineReserveTime + ACTIONS.SendConfirmationCode,
  ReserveTime: CONTROLLERS.OnlineReserveTime + ACTIONS.ReserveTime,
  ValidateReserveTime: CONTROLLERS.OnlineReserveTime + ACTIONS.ValidateReserveTime,
  AddPatientReserveTime: CONTROLLERS.OnlineReserveTime + ACTIONS.AddPatientReserveTime,
  GetUserInfo: CONTROLLERS.user + ACTIONS.GetUserInfo,
  GetPatientReceptions: CONTROLLERS.Reception + ACTIONS.GetPatientReceptions,
  updateReceptionTrackingCode: CONTROLLERS.Reception + ACTIONS.updateReceptionTrackingCode,
  updateReceptionIsVisitedStatus: CONTROLLERS.Reception + ACTIONS.updateReceptionIsVisitedStatus,
  GetSetting: CONTROLLERS.CenterSetting + ACTIONS.GetSetting,
  GetPatients: CONTROLLERS.Patient + ACTIONS.GetPatients,
  GetPatient: CONTROLLERS.Patient + ACTIONS.GetPatient,
  GetDoctorSecretaries: CONTROLLERS.DoctorSecretary + ACTIONS.GetDoctorSecretaries,
  GetWaitingVisit: CONTROLLERS.WaitingVisit + ACTIONS.GetWaitingVisit,
  ClearWaitingVisit: CONTROLLERS.WaitingVisit + ACTIONS.ClearWaitingVisit,
  GetTaminDrugs: CONTROLLERS.FavoriteDrugs + ACTIONS.GetTaminDrugs,
  RemoveTaminDrugs: CONTROLLERS.FavoriteDrugs + ACTIONS.RemoveTaminDrugs,
  GetSalamatDrugs: CONTROLLERS.FavoriteDrugs + ACTIONS.GetSalamatDrugs,
  AddSalamatDrug: CONTROLLERS.FavoriteDrugs + ACTIONS.AddSalamatDrug,
  RemoveSalamatDrugs: CONTROLLERS.FavoriteDrugs + ACTIONS.RemoveSalamatDrugs,
  AggregationOfInstructions: CONTROLLERS.SalamatInsurance + ACTIONS.aggregationOfInstructions,
  QuickSearchDrugWithGeneric: CONTROLLERS.SalamatInsurance + ACTIONS.QuickSearchDrugWithGeneric,
  QuickSearchDrugWithIrc: CONTROLLERS.SalamatInsurance + ACTIONS.QuickSearchDrugWithIrc,
  savePrescription: CONTROLLERS.SalamatInsurance + ACTIONS.savePrescription,
  checkOrder: CONTROLLERS.SalamatInsurance + ACTIONS.checkOrder,
  GetTaminParaClinics: CONTROLLERS.FavoriteParaClinics + ACTIONS.GetTaminParaClinics,
  RemoveTaminParaClinc: CONTROLLERS.FavoriteParaClinics + ACTIONS.RemoveTaminParaClinc,
  AddSalamatParaClinic: CONTROLLERS.FavoriteParaClinics + ACTIONS.AddSalamatParaClinic,
  GetSalamatParaClinics: CONTROLLERS.FavoriteParaClinics + ACTIONS.GetSalamatParaClinics,
  removeSalamatParaClinics: CONTROLLERS.FavoriteParaClinics + ACTIONS.RemoveSalamatParaClinics,
  SalamatServiceSearch: CONTROLLERS.SalamatInsurance + ACTIONS.ServiceSearch,
  SalamatGetDeliveredSamadCodes: CONTROLLERS.SalamatInsurance + ACTIONS.GetDeliveredSamadCodes,
  SalamatCheckDeliveredOrder: CONTROLLERS.SalamatInsurance + ACTIONS.CheckDeliveredOrder,
  SalamatUpdatePrescription: CONTROLLERS.SalamatInsurance + ACTIONS.UpdatePrescription,
  SalamatGetPrescriptionBySamadCode: CONTROLLERS.SalamatInsurance + ACTIONS.GetPrescriptionBySamadCode,
  SalamatGetPrescriptionByPrintCode: CONTROLLERS.SalamatInsurance + ACTIONS.GetPrescriptionByPrintCode,
  SalamatGetSamadOrderedList: CONTROLLERS.SalamatInsurance + ACTIONS.GetSamadOrderedList,
  SalamatDeliverPrescription: CONTROLLERS.SalamatInsurance + ACTIONS.DeliverPrescription,
  SalamatHasMetric: CONTROLLERS.SalamatInsurance + ACTIONS.HasMetric,
  SalamatCreateCitizenSession: CONTROLLERS.SalamatInsurance + ACTIONS.CreateCitizenSession,
  TaminRegistrationPrescription: CONTROLLERS.TaminInsurance + ACTIONS.RegistrationPrescription,
  TaminRegistrationParaclinicPrescription: CONTROLLERS.TaminInsurance + ACTIONS.RegistrationParaclinicPrescription,
  TaminGetPrescription: CONTROLLERS.TaminInsurance + ACTIONS.GetPrescription,
  TaminGetLaboratoryPrescription: CONTROLLERS.TaminInsurance + ACTIONS.GetLaboratoryPrescription,
  TaminEditPrescription: CONTROLLERS.TaminInsurance + ACTIONS.EditPrescription,
  TaminEditLaboratoryPrescription: CONTROLLERS.TaminInsurance + ACTIONS.EditLaboratoryPrescription,
  TaminDeletePrescription: CONTROLLERS.TaminInsurance + ACTIONS.DeletePrescription,
  TaminHastMetric: CONTROLLERS.TaminInsurance + ACTIONS.HastMetric,
  SearchTaminDrugs: ACTIONS.SearchTaminDrugs,
  SearchTaminParaClinic: ACTIONS.SearchTaminParaClinic,
  GetDoctorServices: CONTROLLERS.DoctorService + ACTIONS.GetDoctorServices,
  GetDoctorService: CONTROLLERS.DoctorService + ACTIONS.GetDoctorService,
  GetDoctorServiceMaterials: CONTROLLERS.DoctorService + ACTIONS.GetDoctorServiceMaterials,
  GetDoctorServiceMaterial: CONTROLLERS.DoctorService + ACTIONS.GetDoctorServiceMaterial,
  GetMaterialInsuranceAmounts: CONTROLLERS.MaterialInsuranceAmount + ACTIONS.GetMaterialInsuranceAmounts,
  GetMaterialInsuranceAmount: CONTROLLERS.MaterialInsuranceAmount + ACTIONS.GetMaterialInsuranceAmount,
  AddTaminDrugs: CONTROLLERS.FavoriteDrugs + ACTIONS.AddTaminDrugs,
  AddTaminParaClinic: CONTROLLERS.FavoriteParaClinics + ACTIONS.AddTaminParaClinic,
  CalculateReceptionAmount: CONTROLLERS.Reception + ACTIONS.CalculateReceptionAmount,
  CalculateReceptionAmountForAssistant: CONTROLLERS.Reception + ACTIONS.CalculateReceptionAmountForAssistant,
  AddReception: CONTROLLERS.Reception + ACTIONS.AddReception,
  GetReception: CONTROLLERS.Reception + ACTIONS.GetReception,
  GetReceptionServices: CONTROLLERS.Reception + ACTIONS.GetReceptionServices,
  GetReceptionMaterials: CONTROLLERS.Reception + ACTIONS.GetReceptionMaterials,
  GetReceptionByCustomId: CONTROLLERS.Reception + ACTIONS.GetReceptionByCustomId,
  UpdateReception: CONTROLLERS.Reception + ACTIONS.UpdateReception,
  UpdateReceptionReasonForReferenceId: CONTROLLERS.Reception + ACTIONS.UpdateReceptionReasonForReferenceId,
  RevokeReception: CONTROLLERS.Reception + ACTIONS.RevokeReception,
  AddPrescribeDrug: CONTROLLERS.PrescribeDrug + ACTIONS.AddPrescribeDrug,
  getPrescribedDrugs: CONTROLLERS.PrescribeDrug + ACTIONS.getPrescribedDrugs,
  AddPrescribeLaboratory: CONTROLLERS.PrescribeLaboratory + ACTIONS.AddPrescribeLaboratory,
  GetConsummationInstructions: CONTROLLERS.SalamatParameters + ACTIONS.GetConsummationInstructions,
  GetConsummationSize: CONTROLLERS.SalamatParameters + ACTIONS.GetConsummationSize,
  GetSalamatParaClinicTypes: CONTROLLERS.SalamatParameters + ACTIONS.GetParaClinicTypes,
  GetTaminParaClinicTypes: CONTROLLERS.TaminParameters + ACTIONS.GetParaClinicTypes,
  GetConsumptionInstructions: CONTROLLERS.TaminParameters + ACTIONS.GetConsumptionInstructions,
  GetUsages: CONTROLLERS.TaminParameters + ACTIONS.GetUsages,
  GetConsumptionSize: CONTROLLERS.TaminParameters + ACTIONS.GetConsumptionSize,
  GetAllReasonForReference: CONTROLLERS.ReasonForReference + ACTIONS.getAll,
  addReasonForReference: CONTROLLERS.ReasonForReference + ACTIONS.add,
  deleteReasonForReference: CONTROLLERS.ReasonForReference + ACTIONS.delete,
  editReasonForReference: CONTROLLERS.ReasonForReference + ACTIONS.Edit,
  GetTaminDrugsReason: CONTROLLERS.ReasonForReferenceDrug + ACTIONS.GetTaminDrugs,
  GetSalamatDrugsReason: CONTROLLERS.ReasonForReferenceDrug + ACTIONS.GetSalamatDrugs,
  RemoveSalamatDrugsReason: CONTROLLERS.ReasonForReferenceDrug + ACTIONS.RemoveSalamatDrugs,
  RemoveTaminDrugsReason: CONTROLLERS.ReasonForReferenceDrug + ACTIONS.RemoveTaminDrugs,
  GetTaminParaClinicsReason: CONTROLLERS.ReasonForReferenceParaClinic + ACTIONS.GetTaminParaClinics,
  GetSalamatParaClinicsReason: CONTROLLERS.ReasonForReferenceParaClinic + ACTIONS.GetSalamatParaClinics,
  RemoveSalamatParaClinicsReason: CONTROLLERS.ReasonForReferenceParaClinic + ACTIONS.RemoveSalamatParaClinics,
  RemoveTaminParaClincReason: CONTROLLERS.ReasonForReferenceParaClinic + ACTIONS.RemoveTaminParaClinc,
  AddSalamatDrugReason: CONTROLLERS.ReasonForReferenceDrug + ACTIONS.AddSalamatDrug,
  AddTaminDrugReason: CONTROLLERS.ReasonForReferenceDrug + ACTIONS.AddTaminDrugs,
  AddTaminParaClinicReason: CONTROLLERS.ReasonForReferenceParaClinic + ACTIONS.AddTaminParaClinic,
  AddSalamatParaClinicReason: CONTROLLERS.ReasonForReferenceParaClinic + ACTIONS.AddSalamatParaClinic,
  GetInsuranceEntity: CONTROLLERS.InsuranceEntity + ACTIONS.InsuranceEntity,
  GetBloodLineEntity: CONTROLLERS.BloodLinesEntity + ACTIONS.BloodLinesEntity,
}
